import { IGetIsSchoolDefaultParams } from "./types";

export const getIsSchoolDefault = ({
  defaultSeasons,
  schoolSeasonActive,
}: IGetIsSchoolDefaultParams) => {
  if (defaultSeasons === undefined && schoolSeasonActive === undefined) {
    return true;
  }
  return false;
};



// WEBPACK FOOTER //
// ./src/features/director/pages/seasons/seasonsPage/utils/getIsSchoolDefault/getIsSchoolDefault.ts